import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideFeatureAddonRoutes, provideRootRoutes } from '@core/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let PflegethekeQuestionsFrontendAdminFeature = /*#__PURE__*/(() => {
  let PflegethekeQuestionsFrontendAdminFeature = class PflegethekeQuestionsFrontendAdminFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@pflegetheke/questions/frontend-admin","featureId":"pflegetheke-questions"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineMenuItems({
        adminToolbar: [{
          label: 'Fragen',
          routerLink: 'questions',
          icon: 'film',
          priority: 6,
          items: [{
            label: 'Fragen',
            routerLink: 'questions/questions'
          }, {
            label: 'Themen',
            routerLink: 'questions/categories'
          }]
        }, {
          label: 'Fragen - Aufrufe',
          routerLink: 'statistics/questions',
          displayInGroup: 'statistics',
          icon: 'film'
        }]
      });
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵPflegethekeQuestionsFrontendAdminFeature_BaseFactory;
        return function PflegethekeQuestionsFrontendAdminFeature_Factory(__ngFactoryType__) {
          return (ɵPflegethekeQuestionsFrontendAdminFeature_BaseFactory || (ɵPflegethekeQuestionsFrontendAdminFeature_BaseFactory = i0.ɵɵgetInheritedFactory(PflegethekeQuestionsFrontendAdminFeature)))(__ngFactoryType__ || PflegethekeQuestionsFrontendAdminFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: PflegethekeQuestionsFrontendAdminFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'questions',
          loadChildren: () => import('./questions-admin.module').then(m => m.QuestionsFrontendAdminModule)
        }]), provideFeatureAddonRoutes([{
          useAddonSlot: 'statistics',
          path: 'questions',
          loadChildren: () => import('./statistics/question-statistics.module').then(m => m.QuestionsStatisticsAdminModule)
        }])]
      });
    }
  };
  PflegethekeQuestionsFrontendAdminFeature = __decorate([ClassName("PflegethekeQuestionsFrontendAdminFeature")], PflegethekeQuestionsFrontendAdminFeature);
  return PflegethekeQuestionsFrontendAdminFeature;
})();
export { PflegethekeQuestionsFrontendAdminFeature };